import type { LaunchpadData } from "../types";

const launchpadApps: LaunchpadData[] = [
  // {
  //   id: "cube",
  //   title: "Cube Solver",
  //   img: "img/icons/launchpad/cube.png",
  //   link: "https://cube.zxh.io/"
  // },
  {
    id: "turbon-manager",
    title: "Turbon Manager",
    img: "img/icons/louis-logo.png",
    link: "http://tiny.rocke.top"
  },
  {
    id: "vscode-cloud",
    title: "VSCode-Cloud",
    img: "img/icons/vscode.png",
    link: "https://code.rocke.top/?folder=%2Fhome%2Flouis"
  },
  {
    id: "vscode-site",
    title: "VSCode-Site",
    img: "img/icons/vscode.png",
    link: "http://www.louisyoung.site:10008/"
  },
  {
    id: "jupyter-lab",
    title: "Jupyter Lab",
    img: "img/icons/jupyter.svg",
    link: "http://www.louisyoung.site:8001/lab"
  },
  {
    id: "goland",
    title: "Goland",
    img: "img/icons/goland.svg",
    link: "http://www.louisyoung.site:10051/?notSecureWarning=false"
  },
  {
    id: "clion",
    title: "Clion",
    img: "img/icons/clion.svg",
    link: "http://www.louisyoung.site:10052/?notSecureWarning=false"
  },
  {
    id: "intellij",
    title: "intellij",
    img: "img/icons/intellij.svg",
    link: "http://www.louisyoung.site:10053/?notSecureWarning=false"
  },
  {
    id: "webStorm",
    title: "WebStorm",
    img: "img/icons/webstorm.svg",
    link: "http://www.louisyoung.site:10054/?notSecureWarning=false"
  },
  {
    id: "pycharm",
    title: "Pycharm",
    img: "img/icons/pycharm.svg",
    link: "http://www.louisyoung.site:10055/?notSecureWarning=false"
  },
  {
    id: "centos-server",
    title: "CentOS-Server",
    img: "img/icons/centos.svg",
    link: "http://www.louisyoung.site:1015/CentOS/"
  },
  {
    id: "louis-nas",
    title: "LOUIS-NAS",
    img: "img/icons/drive.svg",
    link: "http://www.louisyoung.site:5000/"
  },
  {
    id: "esxi",
    title: "ESXi",
    img: "img/icons/esxi.svg",
    link: "https://www.louisyoung.site:4430/ui/#/login"
  }
];

export default launchpadApps;
